// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"728473a0","223":"b773c104","613":"d731832f","846":"f15d8e1c"}[chunkId] + ".chunk.js";
};